/* Stormrock · fiche produit (sections sr-product et sr-product-related)
 * Galerie, taille des buds, formats, progression des cadeaux (panier + format choisi), date de livraison,
 * ajout au panier avec ouverture immédiate du cart drawer, cartes « Souvent pris avec ».
 */
(() => {
  if (window.SRProduct) return;
  const q = (s, r) => (r || document).querySelector(s);
  const qa = (s, r) => Array.from((r || document).querySelectorAll(s));
  const NB = ' ';
  const POS = [12.5, 37.5, 62.5, 87.5];
  const isDesk = () => window.matchMedia('(min-width: 990px)').matches;

  function eur(cents, keepZero) {
    const v = Math.max(0, Math.round(cents)) / 100;
    let [i, d] = v.toFixed(2).split('.');
    i = i.replace(/\B(?=(\d{3})+(?!\d))/g, NB);
    return (d === '00' && !keepZero ? i : i + ',' + d) + NB + '€';
  }
  const fill = (txt, map) => String(txt || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

  /* ---------- panier ---------- */
  let cartTotal = null;
  const cartListeners = new Set();
  function readCart() {
    return fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_url ? window.Theme.routes.cart_url.replace(/\/$/, '') : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { cartTotal = c.total_price || 0; cartListeners.forEach((f) => f()); })
      .catch(() => {});
  }
  let cartTimer = 0;
  document.addEventListener('cart:update', () => { clearTimeout(cartTimer); cartTimer = setTimeout(readCart, 250); });

  function tiersOf(root) { return (root.dataset.tiers || '6900,7900,9900,14900').split(',').map(Number); }
  function fillPct(S, t) {
    if (S < t[0]) return (S / t[0]) * POS[0];
    for (let i = 0; i < 3; i++) if (S < t[i + 1]) return POS[i] + ((S - t[i]) / (t[i + 1] - t[i])) * 25;
    return Math.min(100, POS[3] + ((S - t[3]) / 5000) * 12.5);
  }
  /* Repères (mobile) : .col ok / cur, « reste x » ou « ✓ offert », remplissage et éclair */
  /* Repères : la partie pleine = panier (verrouillé), la partie hachurée = panier + format choisi (aperçu).
     .col ok = atteint par le panier, pv = atteint seulement avec le format choisi, cur = prochain repère. */
  function paintRail(box, Lk, P, t, L) {
    if (!box) return { done: 0, pv: 0 };
    const fl = fillPct(Lk, t).toFixed(1) + '%', fp = fillPct(Math.max(P, Lk), t).toFixed(1) + '%';
    qa('[data-srp-fill]', box).forEach((i) => { i.style.width = fl; });
    qa('[data-srp-pv]', box).forEach((i) => { i.style.width = fp; });
    qa('[data-srp-you]', box).forEach((y) => { y.style.left = fp; });
    let done = 0, pv = 0, cur = -1;
    qa('[data-srp-col]', box).forEach((col) => {
      const i = +col.dataset.srpCol;
      const ok = Lk >= t[i], pre = !ok && P >= t[i];
      if (ok) done++; else if (pre) pv++; else if (cur < 0) cur = i;
      col.classList.toggle('ok', ok);
      col.classList.toggle('pv', pre);
      col.classList.toggle('cur', !ok && !pre && cur === i);
      const rs = q('.rs', col);
      if (rs) rs.textContent = ok ? L.offered : pre ? (L.preview || '') : fill(L.rest, { m: eur(Math.ceil((t[i] - P) / 100) * 100) });
    });
    return { done, pv };
  }
  function countText(L, r, always) {
    return fill(L.count, { n: r.done + always, total: 4 + always }) + (r.pv ? ' +' + r.pv : '');
  }

  /* ---------- fiche ---------- */
  function initMain(root) {
    if (root.dataset.srpReady) return;
    root.dataset.srpReady = '1';
    let data = {};
    try { data = JSON.parse(q('script[data-srp-data]', root).textContent); } catch (e) { data = { labels: {} }; }
    const L = data.labels || {};
    const t = tiersOf(root);
    const always = (root.dataset.always || '').split('').filter((c) => c === '1').length;
    if (cartTotal === null) cartTotal = +root.dataset.cart || 0;

    /* galerie */
    const main = q('.srp-mi', root) || q('[data-srp-main] img', root);
    qa('[data-srp-thumb]', root).forEach((th) => th.addEventListener('click', () => {
      qa('.v2-th', root).forEach((x) => x.classList.toggle('on', x === th));
      if (main) { main.removeAttribute('srcset'); main.srcset = th.dataset.srpSrcset || ''; main.src = th.dataset.srpThumb; }
    }));

    /* taille des buds */
    const budInput = q('[data-srp-bud-input]', root);
    const setBud = (b) => {
      qa('[data-srp-bud]', root).forEach((x) => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
      if (budInput && b) budInput.value = b.dataset.srpBud;
    };
    qa('[data-srp-bud]', root).forEach((b) => b.addEventListener('click', () => setBud(b)));
    setBud(q('[data-srp-bud].on', root));

    /* formats */
    const idInput = q('[data-srp-id]', root);
    const price = q('[data-srp-price]', root);
    const cta = q('[data-srp-cta]', root);
    let selPrice = 0;
    let preview = true;   // le format choisi n'est pas encore dans le panier
    const sel = () => q('.v2-sq.on', root);
    const ctaLabel = q('[data-srp-cta-label]', root);
    function selectVariant(btn, push) {
      if (!btn || btn.disabled) return;
      qa('.v2-sq', root).forEach((x) => { const on = x === btn; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
      selPrice = +btn.dataset.price || 0;
      preview = true;
      if (cta) { cta.disabled = false; if (ctaLabel) ctaLabel.textContent = cta.dataset.label || ctaLabel.textContent; }
      if (idInput) idInput.value = btn.dataset.srpVariant;
      if (price) price.textContent = eur(selPrice, true);
      if (push) {
        try { const u = new URL(location.href); u.searchParams.set('variant', btn.dataset.srpVariant); history.replaceState(history.state, '', u); } catch (e) { /* ignore */ }
      }
      paintGifts();
      document.dispatchEvent(new CustomEvent('srp:selection', { detail: { price: selPrice } }));
    }
    qa('.v2-sq', root).forEach((b) => b.addEventListener('click', () => selectVariant(b, true)));

    /* cadeaux */
    const gifts = q('[data-srp-gifts]', root);
    function paintStrips() {
      if (!L.strip) return;
      /* le bandeau sous chaque format n'annonce que ce que CE format ajoute au panier actuel :
         rien si le format ne débloque aucun nouveau cadeau, sinon seulement les nouveaux cadeaux */
      const base = cartTotal || 0;
      let kc = 0; for (let i = 0; i < 4; i++) if (base >= t[i]) kc = i + 1;
      qa('[data-srp-strip]', root).forEach((st) => {
        const total = base + (+st.closest('.v2-sq').dataset.price || 0);
        let k = 0; for (let i = 0; i < 4; i++) if (total >= t[i]) k = i + 1;
        let txt = '';
        if (k > kc) {
          if (kc === 0) txt = L.strip[k];
          else {
            const g = (kc < 2 && k >= 2 ? 5 : 0) + (kc < 3 && k >= 3 ? 10 : 0);
            const parts = [];
            if (g) parts.push('+' + g + ' g');
            if (k >= 4) parts.push(parts.length ? 'goodies' : (L.goodies || 'Pack goodies offert'));
            txt = parts.length === 1 && !g ? parts[0] : parts.join(' + ') + (g ? ' offerts' : '');
          }
        }
        st.classList.toggle('none', !txt);
        const sp = q('span', st); if (sp) sp.textContent = txt;
      });
    }
    function paintGifts() {
      paintStrips();
      if (!gifts) return;
      const Lk = cartTotal || 0;
      const P = Lk + (preview ? selPrice : 0);
      const r = paintRail(gifts, Lk, P, t, L);
      let next = -1;
      qa('[data-srp-card]', gifts).forEach((c) => {
        const i = +c.dataset.srpCard;
        const ok = Lk >= t[i], pre = !ok && P >= t[i];
        if (!ok && !pre && next < 0) next = i;
        c.classList.toggle('ok', ok);
        c.classList.toggle('pv', pre);
        c.classList.toggle('next', !ok && !pre && next === i);
        c.classList.toggle('lock', !ok && !pre && next !== i);
        const gl = q('.gl', c); if (gl) gl.classList.toggle('nx', !ok && !pre && next === i);
        const left = q('[data-srp-left]', c); if (left) left.textContent = fill(L.left, { m: eur(t[i] - P, true) });
        const pc = q('[data-srp-pc]', c); if (pc) pc.textContent = Math.min(99, Math.round((P / t[i]) * 100)) + NB + '%';
      });
      const cnt = q('[data-srp-count]', gifts);
      if (cnt) cnt.textContent = countText(L, r, always);
    }
    window.SRProduct.mainPrice = () => (preview ? selPrice : 0);
    cartListeners.add(paintGifts);
    if (sel()) selectVariant(sel(), false);
    else { preview = false; paintGifts(); }   // tout est en rupture : rien de sélectionné

    /* livraison */
    const dl = q('[data-srp-delivery]', root);
    if (dl) {
      const cutoff = +root.dataset.cutoff || 12, days = +root.dataset.days || 1, sat = root.dataset.saturday === 'true';
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      const work = (d) => d.getDay() !== 0 && (d.getDay() !== 6 || false);
      const ship = new Date(now);
      if (!work(ship) || ship.getDay() === 6 || now.getHours() >= cutoff) {
        do { ship.setDate(ship.getDate() + 1); } while (ship.getDay() === 0 || ship.getDay() === 6);
      }
      const del = new Date(ship);
      let n = days;
      while (n > 0) { del.setDate(del.getDate() + 1); if (del.getDay() !== 0 && (sat || del.getDay() !== 6)) n--; }
      const dows = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      const mons = ['JANV.', 'FÉVR.', 'MARS', 'AVR.', 'MAI', 'JUIN', 'JUIL.', 'AOÛT', 'SEPT.', 'OCT.', 'NOV.', 'DÉC.'];
      const dayName = dows[del.getDay()];
      q('[data-srp-dow]', dl).textContent = dayName.slice(0, 3).toUpperCase() + '.';
      q('[data-srp-day]', dl).textContent = del.getDate();
      q('[data-srp-mon]', dl).textContent = mons[del.getMonth()];
      q('[data-srp-dtext]', dl).innerHTML = fill(L.delivery, { jour: dayName, h: cutoff });
    }

    /* ajout au panier */
    const form = q('[data-srp-form]', root);
    if (form) form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const b = sel();
      if (!b || !cta || cta.disabled) return;
      const props = {};
      if (budInput && budInput.value) props[budInput.name.replace(/^properties\[|\]$/g, '')] = budInput.value;
      addToCart({
        id: b.dataset.srpVariant, cents: +b.dataset.price, title: data.productTitle, variant: b.dataset.title,
        img: (main && (main.currentSrc || main.src)) || data.image, props, button: cta, done: L.added,
        onDone: () => { preview = false; paintGifts(); document.dispatchEvent(new CustomEvent('srp:selection')); },
      });
    });
    readCart();
  }

  /* ---------- ajout au panier (fiche et cartes) ---------- */
  function sectionIds() { return Array.from(new Set(qa('cart-items-component').map((e) => e.dataset.sectionId).filter(Boolean))); }
  function countFrom(sections) {
    for (const id of sectionIds()) {
      const html = sections && sections[id];
      if (typeof html !== 'string') continue;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
      if (el) return parseInt(el.textContent, 10) || 0;
    }
    return undefined;
  }
  async function addToCart(o) {
    const drawer = q('cart-drawer-component');
    let undo = null;
    try {
      if (window.SRCart && typeof window.SRCart.optimistic === 'function') {
        undo = window.SRCart.optimistic({ id: o.id, title: o.title, variant: o.variant, cents: o.cents, qty: 1, shown: o.img, src: o.img });
      }
    } catch (e) { undo = null; }
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) { /* ignore */ } }
    if (o.button) o.button.classList.add('busy');
    try {
      const item = { id: Number(o.id), quantity: 1 };
      if (o.props && Object.keys(o.props).length) item.properties = o.props;
      const body = { items: [item] };
      const ids = sectionIds();
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      const r = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.description || d.message || 'Ce produit n’a pas pu être ajouté');
      if (undo) undo();
      if (typeof o.onDone === 'function') { cartTotal = (cartTotal || 0) + (o.cents || 0); o.onDone(); }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'sr-product', data: { source: 'sr-product', sections: d.sections || null, itemCount: countFrom(d.sections) } },
      }));
      if (o.button && o.done) {
        const lb = q('[data-srp-cta-label], .k-cl', o.button);
        if (lb) { const old = lb.textContent; lb.textContent = o.done; setTimeout(() => { lb.textContent = old; }, 1800); }
      }
    } catch (e) {
      if (undo) undo();
      if (window.SRCart && window.SRCart.toast) window.SRCart.toast(e.message);
      else alert(e.message);
    } finally {
      if (o.button) o.button.classList.remove('busy');
    }
  }

  /* ---------- Souvent pris avec ---------- */
  function initRelated(root) {
    if (root.dataset.srpReady) return;
    root.dataset.srpReady = '1';
    let data = {};
    try { data = JSON.parse(q('script[data-srp-rdata]', root).textContent); } catch (e) { data = { labels: {} }; }
    const L = data.labels || {};
    const t = tiersOf(root);
    const always = +root.dataset.always || 0;
    if (cartTotal === null) cartTotal = +root.dataset.cart || 0;
    let lastPrice = 0;

    function pick(card, btn) {
      qa('.k-ft', card).forEach((x) => { const on = x === btn; x.classList.toggle('k-on', on); x.setAttribute('aria-pressed', on); });
      const pr = q('[data-srp-kprice]', card);
      if (pr && btn) pr.textContent = eur(+btn.dataset.price, true);
    }
    function initCard(card) {
      const fts = qa('.k-ft:not([disabled])', card);
      const want = isDesk() ? q('.k-ft[data-dd="1"]:not([disabled])', card) : q('.k-ft[data-dm="1"]:not([disabled])', card);
      let b = want || fts[Math.min(2, fts.length - 1)];
      if (!isDesk() && b && b.classList.contains('k-x') && !card.classList.contains('k-open')) b = fts[Math.min(2, fts.length - 1)];
      pick(card, b);
      return b;
    }
    const cards = qa('[data-srp-kcard]', root);
    cards.forEach((card, i) => {
      const b = initCard(card);
      if (i === 0 && b) lastPrice = +b.dataset.price;
      qa('.k-ft', card).forEach((btn) => btn.addEventListener('click', () => { if (btn.disabled) return; pick(card, btn); lastPrice = +btn.dataset.price; paint(); }));
      const more = q('[data-srp-more]', card);
      if (more) {
        const ml = more.textContent;
        more.addEventListener('click', () => { const o = card.classList.toggle('k-open'); more.textContent = o ? (L.less || 'Voir moins') : ml; });
      }
      const add = q('[data-srp-add]', card);
      if (add) add.addEventListener('click', () => {
        const btn = q('.k-ft.k-on', card);
        if (!btn) return;
        addToCart({ id: btn.dataset.variant, cents: +btn.dataset.price, title: add.dataset.title, variant: q('b', btn).textContent, img: add.dataset.img, button: add,
          onDone: () => { lastPrice = 0; paint(); } });
      });
      const heart = q('[data-srp-heart]', card);
      if (heart) {
        const key = 'srp_fav_' + heart.dataset.srpHeart;
        let on = false; try { on = localStorage.getItem(key) === '1'; } catch (e) { /* ignore */ }
        heart.setAttribute('aria-pressed', on);
        heart.addEventListener('click', () => { on = !on; heart.setAttribute('aria-pressed', on); try { on ? localStorage.setItem(key, '1') : localStorage.removeItem(key); } catch (e) { /* ignore */ } });
      }
      const vid = q('video.k-alt', card);
      if (vid) {
        const hero = q('.k-hero', card);
        hero.addEventListener('mouseenter', () => { if (!isDesk()) return; if (!vid.src) vid.src = vid.dataset.src; card.classList.add('k-play'); vid.play().catch(() => {}); });
        hero.addEventListener('mouseleave', () => { card.classList.remove('k-play'); try { vid.pause(); } catch (e) { /* ignore */ } });
      }
    });

    function paint() {
      const mainPrice = window.SRProduct.mainPrice ? window.SRProduct.mainPrice() : 0;
      const Lk = cartTotal || 0;
      const P = Lk + mainPrice + lastPrice;
      const band = q('[data-srp-band]', root);
      const r = paintRail(band, Lk, P, t, L);
      const gb = q('[data-srp-gb]', root);
      if (gb) {
        qa('[data-srp-fill]', gb).forEach((i) => { i.style.width = fillPct(Lk, t).toFixed(1) + '%'; });
        qa('[data-srp-pv]', gb).forEach((i) => { i.style.width = fillPct(P, t).toFixed(1) + '%'; });
        qa('[data-srp-you]', gb).forEach((y) => { y.style.left = fillPct(P, t).toFixed(1) + '%'; });
        let next = -1;
        qa('[data-srp-gcol]', gb).forEach((c) => {
          const i = +c.dataset.srpGcol;
          const ok = Lk >= t[i], pre = !ok && P >= t[i];
          if (!ok && !pre && next < 0) next = i;
          c.classList.toggle('ok', ok); c.classList.toggle('pv', pre);
          c.classList.toggle('cur', !ok && !pre && next === i); c.classList.toggle('lock', !ok && !pre && next !== i);
          const d = q('[data-srp-gdot="' + i + '"]', gb);
          if (d) { d.classList.toggle('ok', ok); d.classList.toggle('pv', pre); d.classList.toggle('cur', !ok && !pre && next === i); }
          const left = q('[data-srp-gleft]', c); if (left) left.textContent = fill(L.left, { m: eur(t[i] - P, true) });
        });
      }
      qa('[data-srp-count]', root).forEach((cnt) => { cnt.textContent = countText(L, r, always); });
    }
    /* flèches du carrousel (ordinateur) */
    const rail = q('[data-srp-rail2]', root), nav = q('[data-srp-nav]', root);
    if (rail && nav) {
      const prev = q('[data-srp-prev]', nav), next = q('[data-srp-next]', nav);
      const step = () => { const c = q('.k-card', rail); return c ? c.getBoundingClientRect().width + 20 : rail.clientWidth; };
      const sync = () => {
        const over = rail.scrollWidth > rail.clientWidth + 4;
        nav.classList.toggle('on', over);
        prev.disabled = rail.scrollLeft < 4;
        next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
      };
      prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    cartListeners.add(paint);
    document.addEventListener('srp:selection', paint);
    paint();
    let wasDesk = isDesk();
    window.addEventListener('resize', () => { const d = isDesk(); if (d !== wasDesk) { wasDesk = d; cards.forEach(initCard); } });
  }


  /* ---------- cadeaux : rangée qui défile aussi à la souris (flèches, glisser) et se cale sur le prochain cadeau ---------- */
  function initGiftRail(rail) {
    if (rail.dataset.srpRail2) return;
    rail.dataset.srpRail2 = '1';
    const wrap = document.createElement('div');
    wrap.className = 'c2w';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);
    const mk = (cls, label, d) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'c2-ar ' + cls; b.setAttribute('aria-label', label); b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; wrap.appendChild(b); return b; };
    const prev = mk('prev', 'Cadeaux précédents', 'M15 6l-6 6 6 6');
    const next = mk('next', 'Cadeaux suivants', 'M9 6l6 6-6 6');
    const step = () => { const c = q('.c', rail); return c ? (c.getBoundingClientRect().width + 10) * 2 : 280; };
    const sync = () => {
      const over = rail.scrollWidth > rail.clientWidth + 4;
      wrap.classList.toggle('over', over);
      const atS = rail.scrollLeft < 4, atE = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
      prev.disabled = atS; next.disabled = atE;
      wrap.classList.toggle('at-s', atS); wrap.classList.toggle('at-e', atE);
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // glisser à la souris (sur ordinateur) ; un vrai glissé n'ouvre pas le lien sous le curseur
    let down = null, moved = false;
    rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = { x: e.clientX, l: rail.scrollLeft }; moved = false; });
    window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - down.x; if (Math.abs(dx) > 5) { moved = true; wrap.classList.add('drag'); } if (moved) rail.scrollLeft = down.l - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = null; setTimeout(() => wrap.classList.remove('drag'), 0); });
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    rail.addEventListener('dragstart', (e) => e.preventDefault());
    // au chargement : le prochain cadeau à débloquer est visible
    setTimeout(() => { const n = q('.c.next', rail); if (n && rail.scrollWidth > rail.clientWidth) { const r = rail.getBoundingClientRect(), b = n.getBoundingClientRect(); if (b.right > r.right - 8) rail.scrollLeft += b.right - r.right + 24; } sync(); }, 400);
    sync();
  }

  function boot() {
    qa('[data-srp]').forEach(initMain);
    qa('[data-srp-rel]').forEach(initRelated);
    qa('.srp [data-srp-gifts] .c2').forEach(initGiftRail);
  }
  window.SRProduct = { boot, add: addToCart, mainPrice: null };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => { setTimeout(boot, 30); });
})();
